import React from 'react';

const Loading = () => (<p>LOADING</p>);

export default Loading;
